import type { IReward, IRewardCategory, ISodexoReward } from '@/types/Data'
import type {
  IGetRewardCategoryList,
  IGetRewardList,
  IPayloadReward,
  IPayloadRewardCategory,
} from '@/types/Request'
import { JsonToFormData } from '@/utils-ts'
import BaseService from '../BaseService'

export default class RewardServices extends BaseService {
  GetRewardList(payload: IGetRewardList) {
    return this.GET<IReward[]>(this.PATHS.GET_REWARD_LIST, payload)
  }

  CreateReward(payload: IPayloadReward) {
    return this.POST<string>(this.PATHS.CREATE_REWARD, JsonToFormData(payload))
  }

  UpdateReward(payload: IPayloadReward) {
    return this.POST<IReward>(this.PATHS.UPDATE_REWARD, JsonToFormData(payload))
  }

  DeleteReward(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_REWARD, { Id })
  }

  GetRewardCategoryList(payload: IGetRewardCategoryList) {
    return this.GET<IRewardCategory[]>(this.PATHS.GET_REWARD_CATEGORY_LIST, payload)
  }

  CreateRewardCategory(payload: IPayloadRewardCategory) {
    return this.POST<string>(this.PATHS.CREATE_REWARD_CATEGORY, payload)
  }

  UpdateRewardCategory(payload: IPayloadRewardCategory) {
    return this.POST<string>(this.PATHS.UPDATE_REWARD_CATEGORY, payload)
  }

  DeleteRewardCategory(Id: string) {
    return this.DELETE<void>(this.PATHS.DELETE_REWARD_CATEGORY, { Id })
  }

  GetSodexoRewardList() {
    return this.GET<ISodexoReward[]>(this.PATHS.GET_SODEXO_REWARD_LIST)
  }
}
